import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableTab from "../../../components/tabs/table-tab";
import { REPORTS_HARDWARE_INSTALLATION } from "../../../constants/menu-types";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import HardwareInstallationReportColumn from "../../../models/ColumnDefinitions/HardwareInstallationReportColumn";
import { Lookup } from "../../../models/Lookup";
import LookupTypes from "../../../models/LookupTypes";
import HardwareReportSearch from "../../../models/search/HardwareReportSearch";
import { auditRunReport } from "../../../services/auditService";
import { getDoorNamesWithPagination } from "../../../services/doorService";
import { getAllDeviceNamesWithPagination } from "../../../services/hardwareDeviceTypeService";
import { getHardwareInstallationReport } from "../../../services/reportService";
import { getErrorMessage } from "../../../services/utilities/ServiceError";
import { getZoneNamesWithPagination } from "../../../services/zoneService";

interface HardwareInstallationReportProps {
    reportId: string;
}

const HardwareInstallationReport: FC<HardwareInstallationReportProps> = ({ reportId }) => {
    const { translate } = useLocale();
    const [lookup, setLookup] = useState<Lookup[]>([]);

    useEffect(() => {
        setLookup([
            {
                name: LookupTypes.location,
                values: [],
                dataMethod: getDoorNamesWithPagination,
                searchAccessor: HardwareInstallationReportColumn.find(column => column.accessor === "locName")?.searchOnName
            },
            {
                name: LookupTypes.zone,
                values: [],
                dataMethod: getZoneNamesWithPagination,
                searchAccessor: HardwareInstallationReportColumn.find(column => column.accessor === "zoneName")?.searchOnName
            },
            {
                name: LookupTypes.type,
                values: [],
                dataMethod: getAllDeviceNamesWithPagination,
                searchAccessor: HardwareInstallationReportColumn.find(column => column.accessor === "type")?.searchOnName
            }
        ]);
    }, [])

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = REPORTS_HARDWARE_INSTALLATION;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail, [], reportId) => void) => {
        setDetails(userLoginId, currentMenuDetail, [], reportId);
    }
    // <-- end context

    const getDataMethod = async (listParameters?: any) => {
        try {
            await auditRunReport(reportId);
            return getHardwareInstallationReport(listParameters);
        } catch (error) {
            return Promise.reject(getErrorMessage(error));
        }
    }

    return (<TableContextProvider
        dataMethod={getDataMethod}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={HardwareInstallationReportColumn}
        searchDescriptor={HardwareReportSearch}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        lookup={lookup}>
        <TableTab
            title={''}
            reportTitle={translate.byKey(TranslationKeys.hardwareInstallion)}
            selectRows={false}
            cyName="hardwareInstallation">
        </TableTab>
    </TableContextProvider >
    );
};

export default HardwareInstallationReport;
